module.exports = __webpack_public_path__ + "img/convidar-amigos-verde.4ceddceb.svg";